import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { USPSection } from '@shared/models/usp-section.model';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class USPSectionHttpService {

  constructor(
      private http: HttpClient,
  ) { }

  getAll(): Observable<USPSection> {
      return this.http.get<ApiResponse>(`/usp?sort_by=position&sort_order=asc`).pipe(
          map(res => res.data)
      );
  }

}
